import propTypes from 'prop-types'
import classNames from 'classnames'


export default function Label(props) {
  return (
    <label
      {...props}
      className={classNames([
        'block',
        'text-gray-700',
        'border-0 mb-5 rounded w-full',
        props.className,
      ])}
    >
      {props.children}
    </label>
  )
}


Label.propTypes = {
  className: propTypes.string,
}
